import type { ShareAction } from '#src/app/shared/hooks/share';
import { useShareActions } from '#src/app/shared/hooks/share';

import { useShareLinksQuery } from './useShareLinksQuery';
import { useShareOptions } from './useShareOptions';

type Result = ModelHookResult<{
	shareActions: readonly ShareAction[];
}>;

export function useShareLinks(): Result {
	const { shareLinks } = useShareLinksQuery();
	const options = useShareOptions();
	return {
		data: {
			shareActions: useShareActions(shareLinks, options),
		},
	};
}
